import { Box, Stack, Button, Typography } from '@mui/material';
import { useState } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { Modal } from '@/ui/kit/components/modal';
import { PdpInfoDTO } from '@/types/models';
import { useProfile } from '@/api/hooks/useProfile';
import { useSession } from '@/utils/auth/useSession';
import { PDPEvents } from '@/misc/event-enums';
import SejamSyncModal from '@/containers/profile/components/sync-sejam-modal';
import { ROUTES } from '@/utils/constants';
import { QUERY_KEYS } from '@/utils/constants/query-keys';
import { sendGoogleGTMEvent } from '@/utils/googleGTM';
interface InvestmentCheckLoginProps {
  data: PdpInfoDTO;
}
const texts = {
  investmentTitleBTN: 'سرمایه‌گذاری',
  userSejamAuthenticationTitle: 'احراز هویت سجام',
  investmentDesc: 'برای سرمایه‌گذاری در طرح، وارد حساب کاربری خود شوید. اگر تاکنون حساب کاربری نداشته‌اید، می‌توانید ثبت‌نام کنید.'
};
const InvestmentCheckLogin = ({
  data
}: InvestmentCheckLoginProps) => {
  const {
    data: userDataProfile
  } = useProfile();
  const {
    user: userData
  } = useSession();
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();
  const sendGTM = () => {
    sendGoogleGTMEvent({
      event: 'add_to_cart',
      ecommerce: {
        items: [{
          item_id: data.id,
          item_name: data.title,
          thepercent: Math.floor(+data.providedFund / +data.maxInvestment * 100),
          index: 0,
          login_status: userData ? 'login' : 'logout'
        }]
      }
    });
  };
  const handleInvestment = () => {
    if (userData && userDataProfile) {
      if (userDataProfile.isSejamVerified) {
        sendGTM();
        setTimeout(() => {
          router.push(`/crowdfunding/invest/${data.id}`);
        }, 100);
      } else {
        setIsOpen(true);
      }
    } else {
      setIsOpen(true);
    }
  };
  const showSyncSejamSyncBanner = userData && userData.legalType !== 'legal' && (!userData?.isSejamVerified || userData.faraboorsCode === null || userData.faraboorsCode === '');
  return <>
      <Button sx={{
      flex: 1
    }} variant='contained' color='info' onClick={handleInvestment} disabled={!(data.status === 'pending' || data.status === 'inProgress')} data-gtm-button-id={PDPEvents.Investing} data-sentry-element="Button" data-sentry-source-file="InvestmentCheckLogin.tsx">
        {texts.investmentTitleBTN}
      </Button>

      {!showSyncSejamSyncBanner ? <Modal title={texts.investmentTitleBTN} open={isOpen} onClose={() => setIsOpen(false)}>
          <Stack sx={{
        rowGap: 'var(--spacing_m)',
        maxWidth: '456px',
        minWidth: {
          xs: 'unset',
          md: '456px'
        },
        margin: 'auto',
        p: 'var(--spacing_l)'
      }}>
            <Typography variant='bodyRegular__Wallfund' color='text.text'>
              {texts.investmentDesc}
            </Typography>
            <Box display='flex'>
              <Button variant='contained' color='primary' size='large' sx={{
            flex: 1,
            height: '48px',
            borderColor: 'primary'
          }} href={`${ROUTES.login.href}?${QUERY_KEYS.redirectTo}=${pathname}`} data-gtm-button-id={PDPEvents.ModalSignupLogin}>
                ورود / ثبت‌نام
              </Button>
            </Box>
          </Stack>
        </Modal> : <SejamSyncModal open={isOpen} onClose={() => setIsOpen(false)} initial={true} />}
    </>;
};
export default InvestmentCheckLogin;